/**
 * الرابط ده مالوش شاشة أصلًا.
 *
 * ⚠️ الشاشة دي **للروابط الغلط بس**. أي شاشة معتمدة في التصميم لسه ما
 *    اتبنتش ليها مسار في `ROUTES` وبتتعرض عليها `UnderConstruction`.
 *    اللبس بين الاتنين كان بيخلّي السيستم يكدب على الموظف.
 */
import { Shell } from "@/components/Shell";
import { EmptyState } from "@/components/states/ScreenStates";
import { useRouter, HOME_PATH } from "@/lib/router";

export function NotFound() {
  const { navigate } = useRouter();
  return (
    <Shell title="مالقيناش الصفحة">
      <EmptyState
        title="الصفحة دي مش موجودة"
        hint="يمكن الرابط اتغيّر"
        action={{ label: "رجوع لمكتبي", onClick: () => navigate(HOME_PATH) }}
        fill
      />
    </Shell>
  );
}
